import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export function MarkdownContent({
  text,
  className = '',
}: {
  text: string;
  className?: string;
}) {
  return (
    <div className={`lh-base ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({ children }) => <h1 className="mb-3 mt-1 fs-1 fw-bold text-1000">{children}</h1>,
          h2: ({ children }) => <h2 className="mb-2 mt-3 fs-0 fw-bold text-1000">{children}</h2>,
          h3: ({ children }) => <h3 className="mb-2 mt-3 fs--1 fw-semibold text-900">{children}</h3>,
          h4: ({ children }) => <h4 className="mb-2 mt-3 fs--1 fw-semibold text-900">{children}</h4>,
          p: ({ children }) => <p className="mb-2 lh-base">{children}</p>,
          strong: ({ children }) => <strong className="fw-semibold text-1000">{children}</strong>,
          em: ({ children }) => <em className="fst-italic text-800">{children}</em>,
          ul: ({ children }) => <ul className="mb-2 ps-4">{children}</ul>,
          ol: ({ children }) => <ol className="mb-2 ps-4">{children}</ol>,
          li: ({ children }) => <li className="lh-base">{children}</li>,
          a: ({ href, children }) => (
            <a href={href} target="_blank" rel="noopener noreferrer" className="fw-medium">
              {children}
            </a>
          ),
          blockquote: ({ children }) => (
            <blockquote className="mb-2 border-start border-3 border-primary-subtle bg-200 dark__bg-1000 ps-3 py-1 text-700">
              {children}
            </blockquote>
          ),
          hr: () => <hr className="my-3 border-200" />,
          code: ({ children, ...props }) => (
            <code className="rounded-1 bg-200 dark__bg-1000 px-1 py-0 text-primary" {...props}>
              {children}
            </code>
          ),
          pre: ({ children }) => (
            <div className="mb-2 overflow-hidden rounded-3 border bg-dark text-light">
              <pre className="overflow-auto p-3 lh-base mb-0 text-light">{children}</pre>
            </div>
          ),
          table: ({ children }) => (
            <div className="mb-2 table-responsive">
              <table className="table table-sm table-bordered fs--1 mb-0">{children}</table>
            </div>
          ),
          thead: ({ children }) => <thead>{children}</thead>,
          th: ({ children }) => <th className="fw-semibold text-900">{children}</th>,
          td: ({ children }) => <td className="text-700">{children}</td>,
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
